import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../core/form/Select';
import Button from '../../../core/form/Button';
import FetchSelect from '../../../core/form/FetchSelect';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import { get, startCase } from 'lodash';

const DraftItemCourseListFilter = (props) => (
  <div>
    <Row>
      {props.type === 'course' && (
        <>
          <Column size={1.5}>
            <FetchSelect
              url="/courses"
              label="Course"
              disabled={props.fetching}
              value={get(props.values, 'course', false)}
              onChange={(value) => {
                props.onChange('course', value);
                props.onChange('module', undefined);
                props.onChange('unit', undefined);
                props.onChange('masteryTest', undefined);
              }}
              sortCondition={['order']}
              resultFilter={(course) => {
                course.order = [
                  'Discovery',
                  'Adventures',
                  'Pre A1',
                  'A1',
                  'A1+',
                  'A2',
                  'A2+',
                  'B1',
                  'B1+',
                  'B2',
                  'B2+',
                  'C1',
                  'C1+',
                  'C2',
                ].indexOf(course.name);
                return true;
              }}
              resultTransformer={{
                text: 'name',
                value: 'id',
              }}
            />
          </Column>
          <Column size={2.5}>
            <FetchSelect
              url="/modules"
              label="Module"
              params={{
                query: {
                  course: get(props.values, 'course', ''),
                },
              }}
              placeholder="Select a course to enable modules"
              disabled={props.fetching || !get(props.values, 'course', false)}
              value={get(props.values, 'module', '')}
              onChange={(value) => {
                props.onChange('module', value);
                props.onChange('unit', undefined);
                props.onChange('masteryTest', undefined);
              }}
              sortCondition={['group', 'order']}
              resultTransformer={{
                text: 'name',
                value: 'id',
                textFunc: (row) => `${row.group} - ${row.order} - ${row.name}`,
              }}
            />
          </Column>
          <Column size={2.5}>
            <FetchSelect
              url={`/modules/${get(props.values, 'module', '')}/units`}
              label="Unit"
              placeholder="Select a module to enable units"
              disabled={props.fetching || !get(props.values, 'module', false)}
              value={get(props.values, 'unit', '')}
              onChange={(value) => props.onChange('unit', value)}
              sortCondition={['group', 'order']}
              resultTransformer={{
                text: 'name',
                value: 'id',
                textFunc: (row) => `${row.group} - ${row.order} - ${row.name}`,
              }}
            />
          </Column>
          <Column size={1.5}>
            <FetchSelect
              url={`/modules/${get(props.values, 'module', '')}/mastery-tests`}
              label="Mastery Test"
              placeholder="Select a module to enable mastery tests"
              disabled={props.fetching || !get(props.values, 'module', false)}
              value={get(props.values, 'masteryTest', '')}
              onChange={(value) => props.onChange('masteryTest', value)}
              sortCondition={['modulePercentageToActive']}
              resultTransformer={{
                text: 'modulePercentageToActive',
                value: 'id',
              }}
            />
          </Column>
        </>
      )}
      {props.type === 'placement' && (
        <>
          <Column size={2}>
            <FetchSelect
              url="placement-test-levels"
              fullWidth
              disabled={props.fetching}
              label="Level"
              value={get(props.values, 'placementTestLevel', '')}
              onChange={(value) => props.onChange('placementTestLevel', value)}
              resultTransformer={{
                text: 'level',
                value: 'id',
              }}
            />
          </Column>
          <Column size={6}>
            <FetchSelect
              showSearch
              url="grammars"
              fullWidth
              disabled={props.fetching}
              label="Grammar"
              value={get(props.values, 'grammar', '')}
              onChange={(grammar) => props.onChange('grammar', grammar)}
              resultTransformer={{
                text: 'name',
                value: 'id',
              }}
            />
          </Column>
        </>
      )}
      {props.type === 'certification' && (
        <>
          <Column size={1.5}>
            <FetchSelect
              url="/courses"
              label="Course"
              disabled={props.fetching}
              value={get(props.values, 'course', false)}
              onChange={(value) => {
                props.onChange('course', value);
                props.onChange('module', undefined);
                props.onChange('unit', undefined);
              }}
              sortCondition={['order']}
              resultFilter={(course) => {
                course.order = [
                  'Discovery',
                  'Adventures',
                  'Pre A1',
                  'A1',
                  'A1+',
                  'A2',
                  'A2+',
                  'B1',
                  'B1+',
                  'B2',
                  'B2+',
                  'C1',
                  'C1+',
                  'C2',
                ].indexOf(course.name);
                return true;
              }}
              resultTransformer={{
                text: 'name',
                value: 'id',
              }}
            />
          </Column>
          <Column size={2}>
            <Select
              disabled={props.fetching}
              placeholder="Select..."
              label="Ability"
              value={get(props.values, 'ability', '')}
              onChange={(value) => props.onChange('ability', value)}
              errorText={get(props.errors, 'ability', '')}
              options={[
                { value: 'READING', label: 'Reading' },
                { value: 'WRITING', label: 'Writing' },
                { value: 'SPEAKING', label: 'Speaking' },
                { value: 'LISTENING', label: 'Listening' },
              ]}
            />
          </Column>
          <Column size={4.5}>
            <FetchSelect
              showSearch
              url="grammars"
              fullWidth
              disabled={props.fetching}
              label="Grammar"
              value={get(props.values, 'grammar', '')}
              onChange={(grammar) => props.onChange('grammar', grammar)}
              resultTransformer={{
                text: 'name',
                value: 'id',
              }}
            />
          </Column>
        </>
      )}
      <Column size={1.5}>
        <FetchSelect
          showSearch
          label="Type"
          url="item-types"
          disabled={props.fetching}
          value={get(props.values, 'type')}
          onChange={(value) => {
            props.onChange('type', value);
          }}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={2.5}>
        <TextInput
          label="Item text"
          placeholder="Filter by item text"
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          disabled={props.fetching}
        />
      </Column>
    </Row>
    <Row>
      <Column size={2}>
        <FetchSelect
          showSearch
          label="Character"
          url="characters"
          disabled={props.fetching}
          value={get(props.values, 'character')}
          onChange={(value) => {
            props.onChange('character', value);
          }}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={1.5}>
        <Select
          disabled={props.fetching}
          options={['TO_DO', 'IN_PROGRESS', 'DONE'].map((value) => ({
            value,
            label: startCase(value.replace('_', ' ').toLowerCase()),
          }))}
          label="Status Image"
          value={get(props.values, 'imageAssetsStatus', '')}
          onChange={(value) => props.onChange('imageAssetsStatus', value)}
        />
      </Column>
      <Column size={1.5}>
        <Select
          disabled={props.fetching}
          options={['TO_DO', 'IN_PROGRESS', 'DONE'].map((value) => ({
            value,
            label: startCase(value.replace('_', ' ').toLowerCase()),
          }))}
          label="Status Audio"
          value={get(props.values, 'audioAssetsStatus', '')}
          onChange={(value) => props.onChange('audioAssetsStatus', value)}
        />
      </Column>
      <Column size={1.5}>
        <Select
          disabled={props.fetching}
          options={['TO_DO', 'IN_PROGRESS', 'DONE'].map((value) => ({
            value,
            label: startCase(value.replace('_', ' ').toLowerCase()),
          }))}
          label="Status Video"
          value={get(props.values, 'videoAssetsStatus', '')}
          onChange={(value) => props.onChange('videoAssetsStatus', value)}
        />
      </Column>
    </Row>
    <Row>
      <Column
        size={12}
        style={{
          textAlign: 'right',
        }}
      >
        <Button icon="reload" disabled={props.fetching} onClick={props.onReset} label="Discard changes" />{' '}
        <Button label="Search" icon="search" type="primary" onClick={props.onSearch} disabled={props.fetching} />
      </Column>
    </Row>
  </div>
);

DraftItemCourseListFilter.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
  onSearch: PropTypes.func,
  onReset: PropTypes.func,
};

DraftItemCourseListFilter.defaultProps = {
  fetching: false,
  onSearch: null,
  onReset: null,
};

export default DraftItemCourseListFilter;
